let _ = t => t,
  _t;
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIImage from 'UIComponents/image/UIImage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { ASSIGN_SEAT, REQUEST_SEAT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { getUpgradePointImage } from 'ui-addon-upgrades/ums/getUpgradePointImage';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
import { APP } from '../constants/tracking/App';
import { SCREENS } from '../constants/tracking/Locations';
import FeatureContent from './FeatureContent';
import UpgradePageMerchCard from './UpgradePageMerchCard';
import { getHasSeatPurchaseMotions } from './utils/getHasSeatPurchaseMotions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UpgradeConfigContent__FlexContainer",
  componentId: "sc-1t81ykv-0"
})(["z-index:1;padding-top:64px;padding-bottom:64px;", ";"], breakpoint.tablet(_t || (_t = _`
    padding-right: 48px;
    padding-left: 48px;
  `)));
const ImageWrapper = styled.div.withConfig({
  displayName: "UpgradeConfigContent__ImageWrapper",
  componentId: "sc-1t81ykv-1"
})(["text-align:center;margin:0 auto;"]);
const getImage = upgradeConfig => {
  if (!upgradeConfig.visualKey) {
    return /*#__PURE__*/_jsx(ImageWrapper, {});
  }
  if (upgradeConfig.visualType === 'image') {
    return /*#__PURE__*/_jsx(ImageWrapper, {
      children: /*#__PURE__*/_jsx(UIImage, {
        style: {
          margin: '0 auto'
        },
        src: getUpgradePointImage(upgradeConfig.visualKey)
      })
    });
  }
  return /*#__PURE__*/_jsx(ImageWrapper, {
    children: /*#__PURE__*/_jsx(UIIllustration, {
      name: upgradeConfig.visualKey,
      height: 450
    })
  });
};
const UpgradeConfigContent = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick
}) => {
  const queryParams = getQueryParams();
  const upgradeSource = queryParams.upgradeSource;
  const upgradeData = {
    app: APP,
    screen: SCREENS.UPGRADE_PAGE,
    uniqueId: upgradeConfig.upgradeKey,
    upgradeProduct: ApiNameToUpgradeProductMap[upgradePointApiName] || GENERAL,
    apiName: upgradePointApiName,
    upgradeSource,
    feature: upgradeConfig.feature
  };
  return /*#__PURE__*/_jsxs(FlexContainer, {
    justify: "between",
    align: "center",
    children: [/*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-4",
      children: [/*#__PURE__*/_jsx(FeatureContent, {
        upgradeConfig: upgradeConfig,
        apiName: upgradePointApiName,
        hideHubProductHeader: getHasSeatPurchaseMotions(purchaseMotions)
      }), purchaseMotions.includes(REQUEST_SEAT) && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ebxInterstitialPage.assignSeat.assignSeatText",
          options: {
            productName: I18n.text(`upgrades.products.${upgradeData.apiName}`)
          }
        })
      }), purchaseMotions.includes(ASSIGN_SEAT) && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ebxInterstitialPage.assignSeat.assignSeatText",
          options: {
            productName: I18n.text(`upgrades.products.${upgradeData.apiName}`)
          }
        })
      }), /*#__PURE__*/_jsx(UpgradePageMerchCard, {
        purchaseMotions: purchaseMotions,
        upgradeData: upgradeData,
        upgradePointApiName: upgradePointApiName,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
      })]
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 0,
      basis: "50%",
      className: "p-left-4",
      children: getImage(upgradeConfig)
    })]
  });
};
export default UpgradeConfigContent;